(function () {
  function init(root) {
    if (root.__cc) return; root.__cc = true;
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var i = 0, ms = parseInt(root.getAttribute('data-interval'), 10) || 5000, t;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      slides[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on'); if (dots[i]) dots[i].classList.add('is-on');
    }
    function play() { if (still) return; clearInterval(t); t = setInterval(function () { go(i + 1); }, ms); }
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (n) n.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-dot')); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(t); });
    root.addEventListener('mouseleave', play);
    play();
  }
  function all() { document.querySelectorAll('[data-cc-rotator]').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();

/* Slide-out cart: Clark product cards add to cart without leaving the page,
   then hand off to Horizon's cart drawer using Shopify's standard cart event.
   Oct 10: also re-renders the drawer contents and the cart count directly, so the
   drawer never opens empty even if the theme does not pick up the event. */
(function () {
  var eventsModule = null;
  function getEvents() {
    if (!eventsModule) eventsModule = import('@shopify/events').catch(function () { return null; });
    return eventsModule;
  }
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function' && !d.isOpen) d.open();
  }
  function updateBubble(cart) {
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      var bubble = icon.querySelector('.cart-bubble');
      var count = icon.querySelector('.cart-bubble__text-count');
      if (count) { count.textContent = cart.item_count; count.classList.toggle('hidden', !cart.item_count); }
      if (bubble) bubble.classList.toggle('visually-hidden', !cart.item_count);
    });
  }
  function drawerSection() {
    var d = document.querySelector('[id^="shopify-section-"] #cart-drawer');
    return d ? d.closest('[id^="shopify-section-"]') : null;
  }
  function fetchDrawer() {
    var sec = drawerSection();
    if (!sec) return Promise.resolve(null);
    var id = sec.id.replace('shopify-section-', '');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }
  function paintDrawer(sections) {
    var sec = drawerSection();
    if (!sec || !sections) return;
    var html = sections[sec.id.replace('shopify-section-', '')];
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(sec.id);
    if (fresh) sec.innerHTML = fresh.innerHTML;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-cc-add]') : null;
    if (!form || !window.fetch || !document.getElementById('cart-drawer')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { if (btn.disabled) return; btn.disabled = true; btn.classList.add('is-loading'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding...'; }
    var fd = new FormData(form);
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
    if (ids.length) fd.append('sections', ids.join(','));
    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
    var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    getEvents().then(function (ev) {
      var deferred = null;
      if (ev && ev.CartLinesUpdateEvent) {
        deferred = ev.CartLinesUpdateEvent.createPromise();
        form.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }], promise: deferred.promise }));
      }
      return fetch(addUrl, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          return Promise.all([
            fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
            fetchDrawer()
          ]).then(function (out) {
            var cart = out[0], fresh = out[1];
            var failed = !!res.status;
            var sections = fresh || res.sections;
            if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'clark-product-card', itemCount: Number(fd.get('quantity')) || 1, sections: sections, didError: failed } });
            if (failed) { if (btn) btn.textContent = res.description || res.message || 'Sold out'; return; }
            if (btn) btn.textContent = 'Added!';
            updateBubble(cart);
            setTimeout(function () { paintDrawer(fresh); setTimeout(openDrawer, 120); }, 120);
          });
        })
        .catch(function (err) { if (deferred) deferred.reject(err); form.submit(); });
    }).finally(function () {
      if (!btn) return;
      setTimeout(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = btn.dataset.label || 'Add to cart'; }, 1600);
    });
  });
  if (document.querySelector('form[data-cc-add]')) getEvents();
})();
